import { Checkbox } from "@fluentui/react";
import React from "react";

const MultiSelectFilterList = ({
  items = [],
  getItemId,
  getItemLabel,
  selectedIds,
  onItemToggle,
  onSelectAllChange,
  showAllOption = false,
  allLabel = "All",
  noRecordText = "No record found",
  checkboxStyles,
}) => {
    const itemIds = items.map(getItemId);

    const isItemSelected = (item) =>
        selectedIds != null && selectedIds.includes(getItemId(item));

    const isAllSelected = 
        itemIds.length>0 &&
        itemIds.every((id)=>selectedIds!=null && selectedIds.includes(id));

    const handleAllChange = (checked) => 
    {
        const currentSelected = selectedIds || [];
        const nextSelected = checked
        ? Array.from(new Set([...currentSelected,...itemIds]))
        : currentSelected.filter((id)=> !itemIds.includes(id));
        onSelectAllChange(nextSelected);
    };
    
    return (
        <>
        {showAllOption && items.length>0 && (
            <Checkbox
          label={allLabel}
          name={allLabel}
          styles={checkboxStyles}
          checked={isAllSelected}
          onChange={(e, checked) => handleAllChange(!!checked)}
        />
        )}
        {
            items.map((item) =>{
              const id = getItemId(item);
              const label = getItemLabel(item);
                 return(
                        <Checkbox
                            key={id}
                            label={label}
                            name={label}
                            styles={checkboxStyles}
                            checked={isItemSelected(item)}
                            onChange={(e, checked) => onItemToggle(item, id, !!checked)}
                            />
                 );
            })}
            {items.length === 0 && (
        <span className="study-list-filter-no-record">{noRecordText}</span>
      )}
        </>
    );
    
};
export default MultiSelectFilterList;
